export const OCC_ENDPOINTS = {
  bonusBalance: '/current-user:calculateLoyaltyStatus',
  joinLoyaltyProgram: 'current-user/register-in-loyalty-system',
  loyaltyQr: 'v2/current-user/loyalty-qr',
  oldLoyaltyQr: '/current-user/loyalty-qr',
};
